import { IInventoryPage } from '../../inventory-page.interface';


export const SETTINGS_ACCOUNT_PAGE: IInventoryPage = {
	'route': '/settings/account',
	'title': 'Account',
	'uiReference': [
		'Loading account information',
		'Close profile picture picker',
		'Available profile pictures',
		'Account information',
		'Manage your profile details and account avatar.',
		'First name',
		'Please enter first name!',
		'Last name',
		'Please enter last name!',
		'Email',
		'Please enter email!',
		'Profile picture',
		'Choose profile picture',
		'Select the avatar you want to use across your account.'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/setting-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/settings-pages/general/account/account.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/settings-pages/general/account/account.component.html'
	]
};
